var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"header"},[_c('top-header')],1),_c('div',{staticClass:"con"},[_c('div',{staticClass:"tab"},[_c('left-tab')],1),_c('div',{staticClass:"details"},[_c('router-view',{key:_vm.key})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }